module.exports = __webpack_public_path__ + "static/media/documentation.649c91c1.svg";